import axios from '@/clientAPI.ts'
import {GuestProfileSchema, ProfilePhotoResponseSchema, ProfileRandomAvatarsSchema} from './profile.schema'
import {EditUserPayload, FirstMessagePayload, ProfilePhotoResponseType} from './types'
import {AxiosRequestConfig} from 'axios'
import axiosV3 from '@/clientAPIV3.ts'
import {User, UserV3} from '@/features/authentication/types'
import {MURAL_TYPES} from './completeProfile.schema'
import {HostFeedResponseGeneralV3} from '@/features/feed/types'

export const PROFILE_API = {
    sendProfilePhoto: async (body: FormData, options: AxiosRequestConfig): Promise<ProfilePhotoResponseType> => {
        const url = '/photo'
        const {data} = await axios.post(url, body, {
            ...options,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        return ProfilePhotoResponseSchema.parse(data)
    },
    getGuestProfile: async (userId: number | string, representedUserId?: number | string) => {
        const params = representedUserId
            ? {
                  represented_rookie_id: representedUserId
              }
            : undefined
        const url = `/leaders/${userId}`
        const {data} = await axios.get(url, {params})
        return GuestProfileSchema.parse(data)
    },
    blockUser: async (userId: number) => {
        const url = `/users/${userId}/block`
        return await axios.post(url)
    },
    updateProfile: async (data: EditUserPayload): Promise<User> => {
        const url = '/profile/update'
        return await axios.post(url, data)
    },
    fetchRandomAvatars: async () => {
        const url = '/users/avatars'
        const {data} = await axios.get(url)
        return ProfileRandomAvatarsSchema.parse(data)
    },
    deleteUser: async (userId: number) => {
        const url = '/profile/delete'
        return await axios.post(url, {id: {userId}})
    },
    sendFirstMessage: async ({hostId, message, subscription_package_id, micromorgi_amount}: FirstMessagePayload) => {
        const url = `/rookies/${hostId}/channels`
        return await axios.post(url, {
            message: message,
            subscription_package_id: subscription_package_id,
            micromorgi_amount: micromorgi_amount
        })
    },
    unsubscribeUser: async (token: string) => {
        const url = `/profile/unsubscribe/${token}`
        return await axios.get(url)
    },
    updateCreditCard: async () => {
        const {data} = await axios.post(`/profile/credit-card`)
        return data
    },
    postAvatar: async (body: {path_location: string}) => {
        const {data} = await axios.post('/profile/avatar', body)
        return data
    },
    getMuralOfHost: async (body: {
        hostID?: string | number
        page?: string
        limit?: number
        muralType?: MURAL_TYPES
    }): Promise<HostFeedResponseGeneralV3> => {
        const {hostID, ...params} = body
        const {data} = await axiosV3.get(`/creators/${hostID}/mural`, {params})
        return data
    }
}

export const getSuggestedLeaderV3 = async (): Promise<UserV3[]> => {
    const {data} = await axiosV3.get('/featured-followers')
    return data
}
